import { render, staticRenderFns } from "./MySelectPeople.vue?vue&type=template&id=e66e00a2&scoped=true"
import script from "./MySelectPeople.vue?vue&type=script&lang=js"
export * from "./MySelectPeople.vue?vue&type=script&lang=js"
import style0 from "./MySelectPeople.vue?vue&type=style&index=0&id=e66e00a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66e00a2",
  null
  
)

export default component.exports